import { NgForm, AbstractControl, UntypedFormGroup } from '@angular/forms';
import { ElementRef, ViewChild, Directive } from '@angular/core';
import { TcmBaseFormView } from './tcm-base-form-view';

@Directive()
export class TcmBaseForm implements TcmBaseFormView {

  @ViewChild(NgForm)
  ngForm: NgForm;

  @ViewChild(NgForm, { read: ElementRef })
  ngFormElementRef: ElementRef;

  isLoading: boolean;

  private parent: TcmBaseFormView;

  constructor(parent: TcmBaseFormView = null) {
    this.parent = (parent ? parent : this);
  }

  processSave(saveHandler: any) {
    if (this.isValid() && typeof saveHandler == "function") {
      saveHandler();
    }
  }

  isValid(): boolean {
    this.invalidateForm();
    return this.parent.ngForm.valid;
  }

  async wrapRemoteCallAsync<T = any>(executor: () => Promise<T>): Promise<T> {
    try {

      this.isLoading = true;

      const result = await executor();

      return result;
    }
    finally {
      this.isLoading = false;
    }
  }

  private invalidateForm() {
    const invalidControls = this.collectInvalidControls();
    invalidControls.forEach(c => c.markAsTouched());

    if (this.parent.ngFormElementRef && this.parent.ngFormElementRef.nativeElement) {
      setTimeout(() => {
        const firstInvalidElement = this.parent.ngFormElementRef.nativeElement.getElementsByClassName('invalid')[0];
        if (firstInvalidElement) {
          firstInvalidElement.focus();
        }
      }, 0);
    }
  }

  private collectInvalidControls(): AbstractControl[] {
    const stack: AbstractControl[] = [];

    const controls: AbstractControl[] = [];

    stack.push(...Object.keys(this.parent.ngForm.controls).map(k => this.parent.ngForm.controls[k]).filter(x => x.invalid));

    while (stack.length > 0) {
      const control = stack.pop();

      if (control instanceof UntypedFormGroup) {
        stack.push(...Object.keys(control.controls).map(k => control.controls[k]).filter(y => y.invalid));
      }
      else {
        controls.push(control);
      }
    }

    return controls;
  }
}
